import React from "react";
import { accountingApi } from "../../services/accountingApi";

const money = (n) =>
    `S/ ${Number(n || 0).toLocaleString("es-PE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const parseDetails = (raw) => {
    if (!raw) return [];
    if (Array.isArray(raw)) return raw;
    try {
        return JSON.parse(raw) || [];
    } catch {
        return [];
    }
};

const emptyLabel = (value, fallback = 'No registrado') => value == null || String(value).trim() === '' ? <span className="accEmptyValue">{fallback}</span> : value;

const shortName = (value) => String(value || '').trim().split(/\s+/).filter(Boolean).slice(0, 2).join(' ');

const buildRequester = (movement) => {
    const external = String(movement.requester_external || "").trim();
    const internal = String(movement.requester_user || "").replace(/\s+/g, " ").trim();

    if (external) {
        return { type: "Externo", name: shortName(external) };
    }

    if (internal) {
        return { type: "Interno", name: shortName(internal) };
    }

    return { type: "", name: "-" };
};

export default function MovementsTable({ rows, reload, permissions }) {
    const canDelete = permissions?.canDelete === true;

    const cancel = async (id) => {
        if (!canDelete) return alert("El rol 8 no puede anular movimientos.");
        if (!window.confirm("¿Seguro que deseas anular este movimiento? Si es una transferencia, se anularán ambas partidas bancarias.")) return;
        await accountingApi.cancelMovement(id);
        await reload();
    };

    return (
        <section className="accCard tableWrap accRecords">
            <div className="accRecordsHeader"><div><h3>Movimientos registrados</h3><p>Consulta de ingresos, egresos y transferencias. Desplázate horizontalmente para ver todas las columnas.</p></div><span className="accRecordsCount">{rows.length} {rows.length === 1 ? "registro" : "registros"}</span></div>
            <div className="accRecordsScroll" role="region" aria-label="Tabla de movimientos" tabIndex={0}>
            <table className="accTable">
                <thead>
                    <tr>
                        <th>Fecha</th>
                        <th>Tipo</th>
                        <th>RUC</th>
                        <th>Sede / Ciudad</th>
                        <th>Celular</th>
                        <th>Banco</th>
                        <th>Proveedor</th>
                        <th>Solicitante</th>
                        <th>Creado por</th>
                        <th>Detalle</th>
                        <th>Efectivo</th>
                        <th>Online</th>
                        <th>Total</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {rows.map((x) => {
                        const details = parseDetails(x.payment_details);
                        const requester = buildRequester(x);
                        return (
                            <tr key={x.id}>
                                <td>
                                    {x.created_at
                                        ? new Date(x.created_at).toLocaleString("es-PE", {
                                            year: "numeric",
                                            month: "2-digit",
                                            day: "2-digit",
                                            hour: "2-digit",
                                            minute: "2-digit",
                                            second: "2-digit",
                                            hour12: false,
                                        })
                                        : "-"}
                                </td>
                                <td>
                                    <span
                                        className={`pill ${x.movement_type === "TRANSFER" ? "TRANSFER" : x.operation_type}`}
                                    >
                                        {x.movement_type === "TRANSFER"
                                            ? "TRANSFER"
                                            : x.operation_type}
                                    </span>
                                </td>
                                <td><span className="accCompany">{x.business_name || "-"}</span></td>
                                <td>
                                    {x.movement_type === 'TRANSFER' ? emptyLabel(null, 'No aplica') : emptyLabel(x.sd_sede)}
                                    <br />
                                    <small>{x.movement_type === 'TRANSFER' ? '' : (x.movement_city || 'Ciudad no registrada')}</small>
                                </td>
                                <td>{x.movement_type === 'TRANSFER' ? emptyLabel(null, 'No aplica') : emptyLabel(x.movement_phone)}</td>
                                <td>
                                    {x.movement_type === "TRANSFER"
                                        ? `${x.operation_type === "EGRESO" ? "Salida" : "Ingreso"} - ${x.operation_type === "EGRESO" ? (x.origin_bank_name || "-") : (x.destination_bank_name || "-")}`
                                        : emptyLabel(x.bank_name, "No aplica") }
                                </td>
                                <td>{emptyLabel(x.supplier_name, "No asignado")}</td>
                                <td>
                                    <div className="requesterMini">
                                        <b>{requester.name}</b>
                                        {requester.type && <small>{requester.type}</small>}
                                    </div>
                                </td>
                                <td className="accRegisteredBy">{x.registered_by || "No disponible"}</td>
                                <td className="accDetailCell" title={x.detail || ""}>{emptyLabel(x.detail, "Sin descripción")}</td>
                                <td className="amount">{money(x.cash_amount)}</td>
                                <td className="amount accOnlineCell"><strong>{money(x.online_amount)}</strong>
                                    {x.movement_type === 'TRANSFER' ? <small>Transferencia bancaria</small> : details.filter(p => (p.payment_method || (p.ruc_bank_id ? 'Online' : 'Efectivo')).toLowerCase() !== 'efectivo').map((p, i) => <small key={p.id || i}>{p.payment_method || 'Online'} · {money(p.amount)}{p.bank_label ? ` · ${p.bank_label}` : ''}{p.reference ? ` · Ref: ${p.reference}` : ''}</small>)}
                                </td>
                                <td className={`amount accTotalAmount accSignedTotal ${x.operation_type === "EGRESO" ? "accSignedOut" : "accSignedIn"}`}>{x.operation_type === "EGRESO" ? "−" : "+"}{money(x.amount)}</td>
                                <td>
                                    {canDelete && (
                                        <button type="button" onClick={() => cancel(x.id)}>
                                            Anular
                                        </button>
                                    )}
                                </td>
                            </tr>
                        );
                    })}
                    {rows.length === 0 && <tr><td colSpan={14} className="accRecordsEmpty">No hay movimientos para los filtros seleccionados.</td></tr>}
                </tbody>
            </table>
            </div>
        </section>
    );
}
